import React, { PropTypes } from 'react/addons';

import createOnClickOutside from './createOnClickOutside';


export default function createPortal(Component) {
  const WrappedComponent = createOnClickOutside(Component);

  const Portal = React.createClass({
    propTypes: {
      isOpen: PropTypes.bool.isRequired,
      closeTimeoutMS: PropTypes.number,
    },

    getDefaultProps() {
      return {
        isOpen: false,
        closeTimeoutMS: 0,
      };
    },

    getInitialState() {
      return {
        closing: false,
      };
    },

    componentDidUpdate() {
      this._renderLayer();
    },

    componentWillUnmount() {
      this._unrenderLayer();
      this._clearTimeout();
      document.body.removeChild(this._target);
    },

    componentDidMount() {
      // Appending to the body is easier than managing the z-index of everything on the page.
      // It's also better for accessibility and makes stacking a snap (since components will stack
      // in mount order).
      this._target = document.createElement('div');
      document.body.appendChild(this._target);
      this._renderLayer();
    },

    componentWillReceiveProps(newProps) {
      if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    },

    close() {
      if (this.props.closeTimeoutMS > 0) {
        this.closeWithTimeout();
      } else {
        this.closeWithoutTimeout();
      }
    },

    closeWithTimeout() {
      this.setState({closing: true}, () => {
        this._closeTimeout = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
      });
    },

    closeWithoutTimeout() {
      if (this.isMounted()) {
        this.setState({
          closing: false
        });
      }
    },

    _clearTimeout() {
      if (this._closeTimeout) {
        clearTimeout(this._closeTimeout);
      }
    },

    _renderLayer() {
      // By calling this method in componentDidMount() and componentDidUpdate(), you're effectively
      // creating a "wormhole" that funnels React's hierarchical updates through to a DOM node on an
      // entirely different part of the page.
      this._portal = React.render(this.renderLayer(), this._target);
    },

    _unrenderLayer() {
      React.unmountComponentAtNode(this._target);
    },

    shouldBeClosed() {
      return !this.props.isOpen && !this.state.closing;
    },

    renderLayer() {
      if (this.shouldBeClosed()) {
        return <div />;
      }

      return (
        <WrappedComponent {...this.props}
          closing={this.state.closing}
        />
      );
    },

    render() {
      return null;
    }
  });

  return Portal;
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/createPortal.jsx
 **/